export const convertUserToContext = user => {
  if (!user) {
    return {};
  }

  const context = {
    user: user
  };
  const groups = {};

  if (!user.groups) {
    return context;
  }

  for (const groupType of Object.keys(user.groups)) {
    const groupNames = user.groups[groupType];

    if (groupNames.length > 0 && groupNames[0]) {
      var _user$group_propertie, _user$group_propertie2;

      const groupName = groupNames[0];
      const groupNameMap = {
        group_name: groupName
      }; // Check for group properties

      const groupProperties = (_user$group_propertie = user.group_properties) === null || _user$group_propertie === void 0 ? void 0 : (_user$group_propertie2 = _user$group_propertie[groupType]) === null || _user$group_propertie2 === void 0 ? void 0 : _user$group_propertie2[groupName];

      if (groupProperties && Object.keys(groupProperties).length > 0) {
        groupNameMap['group_properties'] = groupProperties;
      }

      groups[groupType] = groupNameMap;
    }
  }

  if (Object.keys(groups).length > 0) {
    context['groups'] = groups;
  }

  delete context.user['groups'];
  delete context.user['group_properties'];
  return context;
};
export const convertVariant = value => {
  if (value === null || value === undefined) {
    return {};
  }

  if (typeof value === 'string') {
    return {
      key: value,
      value: value
    };
  } else {
    return value;
  }
};
export const convertEvaluationVariantToVariant = evaluationVariant => {
  if (!evaluationVariant) {
    return {};
  }

  let experimentKey = undefined;

  if (evaluationVariant.metadata) {
    experimentKey = evaluationVariant.metadata['experimentKey'];
  }

  const variant = {};
  if (evaluationVariant.key) variant.key = evaluationVariant.key;
  if (evaluationVariant.value) variant.value = evaluationVariant.value;
  if (evaluationVariant.payload) variant.payload = evaluationVariant.payload;
  if (experimentKey) variant.expKey = experimentKey;
  if (evaluationVariant.metadata) variant.metadata = evaluationVariant.metadata;
  return variant;
};
//# sourceMappingURL=convert.js.map